/* eslint-disable consistent-return */
import React, { memo, useState, useEffect } from 'react';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import Img from '@wconcept/wconcept-ui-renewal/components/atoms/Img';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';
import { getResizeImageUrl } from '@wconcept/wconcept-common/utils/domainUtil';
import PlayIcon from '@wconcept/wconcept-ui-renewal/components/molecules/_icon/PlayIcon';
import VeVideo from '@wconcept/wconcept-ui-renewal/components/atoms/VeVideo';
import { Swiper as SwiperClass } from 'swiper/types';
import { IPlayAuthTokenConfig } from '@byteplus/veplayer';

import * as S from './style';

interface IProps {
  username?: string;
  imgSrc?: string;
  videoSrc?: string;
  videoPoster?: string;
  rs?: string;
  vid?: string;
  token?: IPlayAuthTokenConfig;
  getNewToken?: () => Promise<IPlayAuthTokenConfig>;
  parentSwiperRef?: SwiperClass;
  isActive?: boolean;
  itemRef?: React.Ref<HTMLDivElement>;
  onClick?: () => void;
  priority?: boolean;
}

const RecoStylingItem = ({
  username,
  imgSrc,
  videoSrc,
  videoPoster,
  rs,
  vid,
  token,
  getNewToken,
  parentSwiperRef,
  isActive = false,
  itemRef,
  onClick,
  priority,
}: IProps) => {
  // 비디오 관련
  const [videoEl, setVideoEl] = useState<any>(null);
  const [isVideoPlay, setIsVideoPlay] = useState(false);

  const cName = classNameBind([
    'reco-styling-item item',
    isVideoPlay ? 'isLoaded' : '',
  ]);

  // 비디오 음소거 자동재생
  useEffect(() => {
    const videoElement = videoEl?.player;
    if (!videoElement) return;

    if (isActive) {
      videoElement
        .play()
        .then(() => {
          if (videoElement.paused) {
            videoElement.play();
          }
          setIsVideoPlay(true);
        })
        .catch(() => {
          // Handle error if needed
        });
    } else {
      videoElement.pause();
      videoElement.currentTime = 0;
      setIsVideoPlay(false);
    }

    return () => {
      videoElement.pause();
      videoElement.currentTime = 0;
      setIsVideoPlay(false);
    };
  }, [isActive, parentSwiperRef, videoEl]);

  return (
    <S.RecoStylingItem className={cName} ref={itemRef}>
      <Button onClick={onClick}>
        {vid || videoSrc ? (
          <>
            {isActive && (
              <VeVideo
                src={videoSrc}
                muted
                priority={priority}
                loop
                vid={vid}
                getNewToken={getNewToken}
                token={token}
                handleComplete={el => {
                  if (el) setVideoEl(el);
                }}
              />
            )}
            <Img
              className="area-poster"
              priority={priority}
              src={getResizeImageUrl(videoPoster, rs)}
            />
          </>
        ) : (
          <Img src={getResizeImageUrl(imgSrc, rs)} priority={priority} />
        )}
        {(vid || videoSrc) && <PlayIcon size="xs" />}
        <div className="textBox">
          <Text className="username" ellipsis={1}>
            {username}
          </Text>
        </div>
      </Button>
    </S.RecoStylingItem>
  );
};

export default memo(RecoStylingItem);
